import request from "../request";

const api = {
  login: '/login', // 登录
  logout: '/logout',
  getInfo: '/admin/info',
}
export function login(data) {
  return request({
    url: api.login,
    method: 'post',
    data
  })
}

export function logout(params) {
  return request({
    url: api.logout,
    method: 'get',
    params
  })
}

export function getInfo(params) {
  return request({
    url: api.getInfo,
    method: 'get',
    params
  })
}
